module.exports = __webpack_public_path__ + "static/media/Emilio Tiu.8a77554f.png";